var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "orderInquiry dialogSetting" }, [
    _c("div", { staticClass: "orderInquiry__left scrollbar marginRight10" }, [
      _c(
        "div",
        {
          staticStyle: {
            height: "100%",
            display: "flex",
            "flex-direction": "column",
          },
        },
        [
          _c(
            "div",
            { staticClass: "bcWhite box-shadow padding10 marginBottom10" },
            [
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: { placeholder: "订单状态", clearable: "" },
                  model: {
                    value: _vm.queryParams.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "status", $$v)
                    },
                    expression: "queryParams.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "新订单", value: "1" } }),
                  _c("el-option", { attrs: { label: "异常订单", value: "2" } }),
                  _c("el-option", { attrs: { label: "催单", value: "3" } }),
                  _c("el-option", { attrs: { label: "配送异常", value: "4" } }),
                  _c("el-option", {
                    attrs: { label: "取消/退款", value: "5" },
                  }),
                  _c("el-option", { attrs: { label: "预订单", value: "6" } }),
                  _c("el-option", { attrs: { label: "待抢单", value: "7" } }),
                  _c("el-option", { attrs: { label: "待取货", value: "8" } }),
                  _c("el-option", { attrs: { label: "配送中", value: "9" } }),
                  _c("el-option", { attrs: { label: "待处理", value: "10" } }),
                  _c("el-option", { attrs: { label: "已完成", value: "0" } }),
                  _c("el-option", {
                    attrs: { label: "加单完成", value: "12" },
                  }),
                  _c("el-option", { attrs: { label: "已取消", value: "13" } }),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: { placeholder: "订单标签", clearable: "" },
                  model: {
                    value: _vm.queryParams.deliveryType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "deliveryType", $$v)
                    },
                    expression: "queryParams.deliveryType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "同城配送", value: "1" } }),
                  _c("el-option", { attrs: { label: "顾客自提", value: "2" } }),
                  _c("el-option", { attrs: { label: "平台配送", value: "3" } }),
                  _c("el-option", {
                    attrs: { label: "平台切自配", value: "4" },
                  }),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: { placeholder: "订单来源", clearable: "" },
                  model: {
                    value: _vm.queryParams.platType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "platType", $$v)
                    },
                    expression: "queryParams.platType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "美团", value: "1" } }),
                  _c("el-option", { attrs: { label: "饿了么", value: "2" } }),
                  _c("el-option", { attrs: { label: "京东", value: "3" } }),
                  _c("el-option", {
                    attrs: { label: "小程序商城", value: "4" },
                  }),
                  _c("el-option", { attrs: { label: "TOPS订单", value: "6" } }),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: {
                    filterable: "",
                    placeholder: "请选择店铺",
                    clearable: "",
                  },
                  model: {
                    value: _vm.queryParams.cshop,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "cshop", $$v)
                    },
                    expression: "queryParams.cshop",
                  },
                },
                _vm._l(_vm.shopOptions, function (item) {
                  return _c("el-option", {
                    key: item.sid,
                    attrs: { label: item.cname, value: item.sid },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: {
                    filterable: "",
                    placeholder: "请选择门店",
                    clearable: "",
                  },
                  model: {
                    value: _vm.queryParams.rstore,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "rstore", $$v)
                    },
                    expression: "queryParams.rstore",
                  },
                },
                _vm._l(_vm.storeList, function (item) {
                  return _c("el-option", {
                    key: item.sid,
                    attrs: { label: item.cname, value: item.sid },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  ref: "sortSelect",
                  staticClass: "marginRight10",
                  attrs: { placeholder: "排序方式" },
                  model: {
                    value: _vm.sortingValue,
                    callback: function ($$v) {
                      _vm.sortingValue = $$v
                    },
                    expression: "sortingValue",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "下单时间倒序", value: "s_order_time-0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "下单时间正序", value: "s_order_time-1" },
                  }),
                  _c("el-option", {
                    attrs: { label: "抢单时间倒序", value: "s_receive_time-0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "抢单时间正序", value: "s_receive_time-1" },
                  }),
                  _c("el-option", {
                    attrs: { label: "预计送达倒序", value: "s_wish_time-0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "预计送达正序", value: "s_wish_time-1" },
                  }),
                ],
                1
              ),
              _c("el-date-picker", {
                staticClass: "marginTop10",
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  align: "right",
                  type: "daterange",
                  "unlink-panels": "",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.orderDate,
                  callback: function ($$v) {
                    _vm.orderDate = $$v
                  },
                  expression: "orderDate",
                },
              }),
              _vm._v("  "),
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "", placeholder: "顾客地址" },
                model: {
                  value: _vm.address,
                  callback: function ($$v) {
                    _vm.address = $$v
                  },
                  expression: "address",
                },
              }),
              _c(
                "el-input",
                {
                  staticClass: "marginLeft10 w300 input-with-select",
                  attrs: { clearable: "", placeholder: "手机、订单号、TOPS号" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.changeListData.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.changeListData },
                    slot: "append",
                  }),
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.reset } },
                [_vm._v("重置")]
              ),
              _vm._v("   快速查询 "),
              _c("el-switch", {
                staticClass: "marginLeft20",
                attrs: { "active-value": 1, "inactive-value": 2 },
                model: {
                  value: _vm.fast,
                  callback: function ($$v) {
                    _vm.fast = $$v
                  },
                  expression: "fast",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "bcWhite scrollbar box-shadow",
              staticStyle: { height: "100%" },
            },
            [
              _c("orderListForInquiry", {
                ref: "orderList",
                staticClass: "hHP",
                on: {
                  changeListInfoData: _vm.changeListInfoData,
                  handleEndSearch: _vm.handleEndSearch,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "orderInquiry__right flex" }, [
      _c(
        "div",
        { staticClass: "bcWhite box-shadow", staticStyle: { flex: "1" } },
        [
          _c("OrderListInfo", {
            ref: "orderListInfo",
            staticClass: "bcWhite box-shadow",
            on: { changeListData: _vm.changeListData },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }